<script setup lang="ts">
import { NLayout, NLayoutSider, NLayoutContent, NIcon } from 'naive-ui'
import { augmentifyLogo, homeIcon, augmentIcon, projectsIcon, meetingsIcon, settingsOutline } from "@/assets/utils/icons";
import FooterComponent from "@/components/FooterComponent.vue";
import { LogOutSharp } from '@vicons/material'
import type { MenuItem } from '@/ts/interfaces/layout/MenuItem';
import { useAuthLogoutStore } from "@/stores/auth/logout.store";

const authLogoutStore = useAuthLogoutStore()

const handleLogout = () => {
  authLogoutStore.logout()
}

const sideMenuRoutes: Array<MenuItem> = [
  {
    text: 'Home',
    icon: homeIcon,
    routeName: 'client-home',
    show: true
  },
  {
    text: 'Augment',
    icon: augmentIcon,
    routeName: 'client-home',
    show: false
  },
  {
    text: 'Projects',
    icon: projectsIcon,
    routeName: 'client-projects-index',
    show: true
  },
  {
    text: 'Meetings',
    icon: meetingsIcon,
    routeName: 'meetings',
    show: true
  },
]
</script>

<template>
  <n-layout position="absolute">
    <n-layout has-sider position="absolute">
      <n-layout-sider width="250" class="side-menu-container" content-class="side-menu flex-container flex-dir-column">
        <div class="side-menu-logo" v-html="augmentifyLogo"></div>

        <div class="side-menu-links-container flex-container flex-dir-column">
          <template v-for="(route, key) in sideMenuRoutes" :key="key">
            <router-link v-if="route.show" class="flex-container side-menu-link" :to="{ name: route.routeName }">
              <div class="icon" v-html="route.icon"></div>
              <span class="side-menu-text">{{ route.text }}</span>
            </router-link>
          </template>
        </div>

        <div class="side-menu-footer-links-container">
          <router-link class="flex-container side-menu-link" :to="{ name: 'settings' }">
            <div class="icon" v-html="settingsOutline"></div>
            <span class="side-menu-text">Settings</span>
          </router-link>

          <a class="flex-container flex-center side-menu-link" @click.prevent="handleLogout">
            <n-icon class="icon">
              <log-out-sharp></log-out-sharp>
            </n-icon>
            <span class="side-menu-text">Log out </span>
          </a>
        </div>
      </n-layout-sider>

      <n-layout>
        <n-layout-content content-class="client-layout-content">
          <router-view></router-view>
        </n-layout-content>
        <footer-component position="absolute"></footer-component>
      </n-layout>
    </n-layout>
  </n-layout>
</template>

<style lang="scss">
.side-menu {
  padding: 120px 0 50px;

  &-logo {
    margin-bottom: 34px;
    margin-left: auto;
    margin-right: auto;
  }

  &-links-container {
    gap: 14px;
  }

  &-link {
    padding: 14px 14px 14px 94px;
    position: relative;

    &:before {
      content: "";
      width: 100%;
      height: 100%;
      transition: all 300ms ease-in-out;
      top: 0;
      left: -100%;
      position: absolute;
      background: linear-gradient(90deg, #DFDDED 15%, #FFF 100%, rgba(130, 59, 112, 0.00) 100%);
    }

    &:hover {
      .side-menu-text, .icon {
        font-weight: 700;
        color: $purple-light;
      }
    }

    &.router-link-active {
      .side-menu-text, .icon {
        font-weight: 700;
        color: $purple-medium;
      }
    }

    &:hover {
      &:before {
        left: 0;
      }
    }

    .side-menu-text, .icon {
      z-index: 1;
      color: $royal-blue;
      transition: all 100ms ease-in-out;
    }

    .icon {
      margin-right: 12px;
      display: flex;
      align-items: center;
    }
  }

  &-footer-links-container {
    gap: 14px;
    margin-top: auto;
  }
}
</style>